<template>
  <div>
    <el-dialog
      title="自定义配置"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      append-to-body
      class="privateDialong"
    >
      <i-draggable :dragData="listData" ref="drag" v-on="$listeners"></i-draggable>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" class="btn-del" @click="dialogVisible = false"
          >{{$t('common.btn.cancel')}}</el-button
        >
        <el-button
          size="small"
          class="btn-que"
          type="primary"
          @click="getSortData"
          >{{$t('common.btn.confirm')}}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import iDraggable from "./Draggable.vue";
export default {
  components: {
    iDraggable,
  },
  props: ["listData"],
  data() {
    return {
      dialogVisible: false,
      checkList: []
    };
  },
  mounted() {
  },
  methods: {
    getSortData() {
      this.$refs.drag.sortFun();
      this.$emit("changeSort", this.$refs.drag.dragList);
      this.dialogVisible = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="less" scoped>
.privateDialong {
  /deep/.el-dialog {
    text-align: left;
    .el-dialog__header {
      padding: 10px 20px;
      background-color: #409eff;
      .el-dialog__title {
        color: #fff;
      }
      .el-dialog__headerbtn {
        top: 12px;
        .el-dialog__close {
          color: #fff;
          font-size: 20px;
        }
      }
    }
    .el-dialog__body {
      padding: 20px 20px 10px;
      .el-checkbox {
        color: #333;
        width: 100%;
        line-height: 30px;
        padding-left: 30px;
        .el-checkbox__input.is-checked .el-checkbox__inner {
          background-color: #409eff;
          border-color: #409eff;
        }
        .el-checkbox__input.is-focus .el-checkbox__inner {
          border-color: #409eff;
        }
      }
    }
    .el-dialog__footer {
      padding: 0 20px 30px;
      .el-button {
        font-size: 14px;
        width: 64px;
        height: 30px;
        border-radius: 2px;
        padding: 0;
      }
      .btn-que {
        background-color: #409eff;
        border-color: transparent;
      }
      .btn-del {
        background-color: #fff;
        color: #333;
        border-color: #b8b8b8;
      }
    }
  }
}
</style>
